import AWS from 'aws-sdk';
import {
  ALLOWED_FILE_TYPES,
  MAX_FILE_SIZE,
  S3_BUCKET,
} from '../constants/global.constants';

// Configure AWS with your credentials
AWS.config.update({
  accessKeyId: S3_BUCKET.ACCESS_KEY_ID,
  secretAccessKey: S3_BUCKET.ACCESS_KEY_SECRET,
  region: S3_BUCKET.REGION,
});
const s3 = new AWS.S3();

// Function to check if file type is allowed
function isAllowedFileType(file: File) {
  // const fileType = file.type.split('/')[0];
  const fileTypes = file.type.split('/');
  if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    return true;
  }
  return (
    ALLOWED_FILE_TYPES.includes(fileTypes[0]) ||
    ALLOWED_FILE_TYPES.includes(fileTypes[1])
  );
}

// Function to check if file size is within limits
function isFileSizeWithinLimits(file: File) {
  const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE * 1024 * 1024;
  return file.size <= MAX_FILE_SIZE_BYTES;
}

export function isInvalidFile(file: File) {
  if (!file) {
    console.error('File not selected');
    return 'File not selected';
  }
  if (!isAllowedFileType(file)) {
    console.error('Unsupported file type.');
    return `Supported file types. (${ALLOWED_FILE_TYPES.join(', ')})`;
  }

  if (!isFileSizeWithinLimits(file)) {
    console.error('File size exceeds the limit.');
    return `File size exceeds the limit (i.e ${MAX_FILE_SIZE} MB)`;
  }
  return false;
}

// Upload file to S3
export default function (
  selectedFile: File,
  onProgress: (progress: any) => void,
) {
  if (!isAllowedFileType(selectedFile)) {
    console.error('Unsupported file type.');
    return Promise.reject('Unsupported file type.');
  }

  if (!isFileSizeWithinLimits(selectedFile)) {
    console.error('File size exceeds the limit.');
    throw Promise.reject('File size exceeds the limit.');
  }
  const Key = `${selectedFile.name}`;
  const params = {
    Bucket: S3_BUCKET.NAME,
    Key,
    Body: selectedFile,
    ContentType: selectedFile.type,
  };

  return new Promise((resolve, reject) => {
    s3.upload(params, (err: any, data: AWS.S3.ManagedUpload.SendData) => {
      if (err) {
        console.error('Error uploading file:', err);
        reject(err);
      } else {
        const uploadData = data as AWS.S3.ManagedUpload.SendData;
        resolve(selectedFile);
        console.log(uploadData)
      }
    }).on('httpUploadProgress', onProgress);
  });
}
